export const initialState = {
  points: null,
  loading: false,
};
